import { Box, Grid } from '@mui/material';
import { Button, Dialog, H1, P1R } from 'src/components';
import { useTranslation } from 'react-i18next';
import warningSign from '../../assets/warningSign.svg';

type Props = {
  errorMessage: string;
  onClose: () => void;
  title?: string;
};

function ActionForbiddenPopup({ errorMessage, onClose, title }: Props) {
  const { t } = useTranslation();

  return (
    <Dialog open onClose={onClose} aria-labelledby="customized-dialog-title">
      <Box
        sx={{
          mb: 5,
          mt: 2,
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'column',
        }}
      >
        <Box>
          <img src={warningSign} alt="warning" />
        </Box>
        <H1 align="center" sx={{ mt: 5, mb: 3 }}>
          {title || t('actionForbiddenPopup.actionIsForbidden')}
        </H1>
        <P1R sx={{ textAlign: 'center', whiteSpace: 'pre-line' }}>{errorMessage}</P1R>
      </Box>

      <Grid container justifyContent="center" columnSpacing={2} sx={{ mb: 5 }}>
        <Grid item xs={6}>
          <Button primary onClick={onClose} sx={{ width: '100%', textTransform: 'capitalize' }}>
            {t('common.okGotIt')}
          </Button>
        </Grid>
      </Grid>
    </Dialog>
  );
}

export default ActionForbiddenPopup;
